import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { savePaymentMethod } from "../Redux/Actions/cartActions";
import Header from "./../components/Header";
import "../App.css";
import "./payment.css";

const PaymentScreen = () => {
  window.scrollTo(0, 0);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const cart                = useSelector((state) => state.cart);
  const { shippingAddress } = cart;
  const { userInfo }        = useSelector((state) => state.userLogin);
  const guest               = useSelector((state) => state.guest);

  const [paymentMethod, setPaymentMethod] = useState("Square");

  useEffect(() => {
    // Check both Redux state and localStorage — localStorage is the
    // source of truth for full-page reloads before Redux rehydrates
    const guestFromStorage = (() => {
      try {
        const raw = localStorage.getItem("guestInfo");
        return raw ? JSON.parse(raw) : null;
      } catch {
        return null;
      }
    })();

    const isGuest    = guest?.isGuest === true || guestFromStorage?.isGuest === true;
    const isLoggedIn = !!userInfo;

    if (!isLoggedIn && !isGuest) {
      navigate("/login?redirect=shipping");
      return;
    }

    if (!shippingAddress?.street1) {
      navigate("/shipping");
    }
  }, [userInfo, guest, shippingAddress, navigate]);

  const paymentOptions = [
    { id: "square", name: "Credit Card", value: "Square", icon: "fa-credit-card" },
  ];

  const submitHandler = (e) => {
    e.preventDefault();
    dispatch(savePaymentMethod(paymentMethod));
    navigate("/placeorder");
  };

  return (
    <>
      <Header />
      <div className="container d-flex justify-content-center align-items-center login-center">
        <form
          className="Login2 col-md-8 col-lg-5 col-11"
          onSubmit={submitHandler}
        >
          <h6 className="payment-title">SELECT PAYMENT METHOD</h6>
          <div className="payment-container">
            {paymentOptions.map((option) => (
              <div className="radio-container" key={option.id}>
                <input
                  className="form-check-input"
                  type="radio"
                  id={option.id}
                  name="paymentMethod"
                  value={option.value}
                  checked={paymentMethod === option.value}
                  onChange={(e) => setPaymentMethod(e.target.value)}
                />
                <label className="form-check-label" htmlFor={option.id}>
                  <i className={`fas ${option.icon} mr-2`}></i>
                  {option.name}
                </label>
              </div>
            ))}
          </div>
          <button type="submit" className="payment-button">
            Continue to Checkout
          </button>
        </form>
      </div>
    </>
  );
};

export default PaymentScreen;